import styled from 'styled-components';

import { SkeletonElement, theme } from '@notino/react-styleguide-v20';

import { ProductSkeleton } from '@sharedComponents/Skeletons';

export const StyledProductSkeleton = styled(ProductSkeleton)`
  margin: auto;
  margin-bottom: 1rem;
  box-sizing: border-box;
`;

export const StyledTitle = styled(SkeletonElement)`
  height: 1.5rem;
  width: 16rem;
  max-width: 100%;
  border-radius: 0.25rem;
`;

export const StyledFooter = styled.div`
  background-color: ${theme.color.background.disabled};
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
`;

export const StyledPrice = styled(SkeletonElement)`
  height: 1.75rem;
  width: 4.25rem;
  margin-left: 1.5rem;
  border-radius: 0.25rem;
`;

export const StyledPriceTitle = styled(SkeletonElement)`
  width: 10rem;
  height: 1.25rem;
  border-radius: 0.25rem;
`;
